import { render, staticRenderFns } from "./DevelopedBy.vue?vue&type=template&id=728e3d7c&scoped=true&"
import script from "./DevelopedBy.vue?vue&type=script&lang=js&"
export * from "./DevelopedBy.vue?vue&type=script&lang=js&"
import style0 from "./DevelopedBy.vue?vue&type=style&index=0&id=728e3d7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728e3d7c",
  null
  
)

export default component.exports